import { MenuList } from "./menuList";
import { UserMenuList } from "./userMenuList";

/*regex validations */
const matches = {
  // name: /^[A-Za-z0-9\s]+(([',. -][A-Za-z0-9\s ])?[A-Za-z0-9\s]*)*$/g,
  name: /^[a-zA-Z]+(?:[\s.]+[a-zA-Z]+)*$/, ///^[a-zA-Z-'. ]+$/,
  specialCharName: /^[a-zA-Z\s.&]+$/i,
  // address: /^[a-zA-Z0-9-,. ]+$/,
  transactionID:/^(?!0)[a-zA-Z0-9]+$/,
  address: /^(?![0-9]+\/[0-9]+(?:\s|$))[a-zA-Z0-9\s,.-/]+$/,
  phone: /^[6-9]{1}[0-9]{9}$/,
  panNumber: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/,
  // pinCode: /^\d{6}$/,
  pinCode:  /^(?!0)\d+(\.\d+)?$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  // email: /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
  area: /^(?!0)\d+(\.\d+)?$/,
  authorisedValid:/^(0|\d+(\.\d+)?)$/,
  // area: /^\d+(\.\d+)?$/,
  // flexSize: /^\d+\s*[Xx]\s*\d+$/i,
  flexSize:/\b(?:[1-9][0-9]*|0?[1-9][0-9]*)\s*[Xx]\s*(?:[1-9][0-9]*|0?[1-9][0-9]*)\b/,
  breadmatch: /\/(view|update|add|edit)(?:\/([\w-]+)(?:\/([\w-]+))?)?\/?$/,
  number: /^[0-9]+$/,
  decimalNumber: /^\d+(\.\d{1,2})?$/,
  alphaNumeric: /^[a-zA-Z0-9 ]*$/,
  ifscCode: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  positivenumber: /^(?=.*[1-9])\d*\.?\d+$/,
  specialChar : /^[a-zA-Z\s()!@#$%^&*_-]+$/g,
  allowOnlyCharacter : /^[a-zA-Z0-9-'. ]+$/,
  checkGSTNumber : /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/
};
const SUPER_ADMIN = "super_admin";
const ASSOCIATE_BUYER_SLUG = "associate_buyer";

const associate_buyer = {
  family_AB_no: {
    label: "Family A.B. No.*",
    requiredErrorMsg: "Family A.B. No. is required"
  },
  family_AB_name: {
    label: "Family A.B. Name*",
    requiredErrorMsg: "Family A.B. Name is required"
  },
  family_AB_phone: {
    label: "Family A.B. Phone No.",
    requiredErrorMsg: "Family A.B. Phone No. is required"
  },
  family_AB_joining_date: {
    label: "Joining Date*",
    key: "family_AB_joining_date"
    // requiredErrorMsg: "Family A.B. Phone no is required"
  }
};
const PermissionAction = {
  ADD: "add",
  EDIT: "edit",
  VIEW: "view",
  DELETE: "delete",
  DOWNLOAD: "download",
  UPLOAD: "upload",
  IMPORT: "import",
  EXPORT: "export",
  BULK_DELETE: "bulk_delete",
  BULK_DOWNLOAD: "bulk_download",
  BULK_UPLOAD: "bulk_upload",
  BULK_IMPORT: "bulk_import",
  BULK_EXPORT: "bulk_export"
};

// Function to return submenu according to route
const searchMenu = (menuItems, term, parent = null) =>
  menuItems.reduce((result, menuItem) => {
    if (!result && menuItem.path === term) {
      return menuItem;
    }

    if (menuItem.list && menuItem.list.length > 0) {
      return result || searchMenu(menuItem.list, term, menuItem);
    }

    return result;
  }, null);
// Function for checking the action according to permission
const actionsPermissionValidator = (modulePath, action) => {
  var slugPermission = JSON.parse(localStorage.getItem("slugPermission"));
  if (slugPermission) {
    const userParsed = slugPermission;
    const currentMenuFromList = searchMenu(MenuList, modulePath.replace(matches.breadmatch, ""));

    if (userParsed && currentMenuFromList) {
      const filterpermission = userParsed.filter(
        (item) => item.module_slug === currentMenuFromList.module_slug
      );

      return (
        filterpermission?.[0]?.permissions.length > 0 &&
        filterpermission?.[0]?.permissions?.includes(action)
      );
    }
  }
  return false;
};

// Function for checking the action according to permission
const actionsUserPermissionValidator = (modulePath, action) => {
  var slugPermission = JSON.parse(localStorage.getItem("slugPermission"));
  if (slugPermission) {
    const userParsed = slugPermission;
    const currentMenuFromList = searchMenu(
      UserMenuList,
      modulePath.replace(matches.breadmatch, "")
    );

    if (userParsed && currentMenuFromList) {
      const filterpermission = userParsed.filter(
        (item) => item.module_slug === currentMenuFromList.module_slug
      );

      return (
        filterpermission?.[0]?.permissions.length > 0 &&
        filterpermission?.[0]?.permissions?.includes(action)
      );
    }
  }
  return false;
};

/* validation messages */
const validationMessage = {
  char1Min: "Atleast 1 characters are required",
  char2Min: "Atleast 2 characters are required",
  char3Min: "Must be at least 3 characters long",
  char5Min:"Must be at least 5 characters long",
  char6Min: "Atleast 6 characters long",
  char8Min: "Atleast 8 characters long",
  char9Min: "Must be at least 9 characters long with decimal",
  char10Min: "Atleast 10 characters long",
  char11Min: "Atleast 10 characters long",
  char10Max: "Must be 10 characters long",
  char3Max: "Must be 3 characters long",
  char17Max: "Must be 17 characters long with decimal",
  char15Max: "Must be 15 characters long",
  char25Max: "Must be 25 characters long",
  char35Max: "Must be 35 characters long",
  char50Max: "Must be 50 characters long",
  char75Max: "Must be 75 characters long",
  char9MinAC: "Atleast 9 characters long",
  spclCharNotAllowed: "Special characters are not allowed",
  validatearea:
    "Only decimal numeric characters are allowed and must be within the range -90 to 90",
  validatelongitudearea:
    "Only decimal numeric characters are allowed and must be within the range -180 to 180",
  validatelat: "Latitude must be within the range -90 to 90",
  validatelong: "Longitude must be within the range -180 to 180",
  invalidPhNo: "Invalid phone number",
  invalidEmailID: "Invalid email id",
  notEmpty: "Value can't be empty",
  numberAllow: "Only numbers are allowed",
  invalidValue:"Invalid value",
  alphaNumericMsg: "Only alphanumeric characters are allowed",
  passwordMatch: "Passwords must match",
  invalidTransaction: "Invalid transaction id"
};

const locationType = [
  { label: "Village", value: "village" },
  { label: "Town", value: "town" },
  { label: "City", value: "city" },
  { label: "Metro city", value: "metro_city" }
];
const floorType = [
 
  { label: "Basement", value: "basement" },
  { label: "Ground", value: "ground" },
  { label: "1st", value: "1st" },
  { label: "2nd and Above", value: "2nd and above" },
];

const saleTargetOptions = [
  {
    label: "2 Lakhs - 3 Lakhs",
    value: "2 Lakhs - 3 Lakhs"
  },
  {
    label: "4 Lakhs - 5 Lakhs",
    value: "4 Lakhs - 5 Lakhs"
  },
  { label: "Over 5 Lakhs", value: "Over 5 Lakhs" }
];

const bussinessIdentityOptions = [
  { label: "Prop", value: "Prop" },
  { label: "LLP", value: "LLP" },
  { label: "Partnership", value: "Partnership" },
  { label: "Ltd.", value: "Ltd" },
  { label: "Pvt. Ltd.", value: "Pvt Ltd" }
];
const premisesTypeOptions = [
  { label: "Owned", value: "owned" },
  { label: "Relative's", value: "relative" },
  { label: "Leased", value: "leased" },
  { label: "Rented", value: "rented" }
];

const dummyDeropDown = [
  { label: "Item 1", value: 1 },
  { label: "Item 2", value: 2 },
  { label: "Item 3", value: 3 },
  { label: "Item 4", value: 4 },
  { label: "Item 5", value: 5 }
];
const rolestatus = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" }
];
const paymentStatus=[
  {label:"Approved",value:"approved"},
  {label:"Pending",value:"pending"},
  {label:"Action Required",value:"action_required"},
  {label:"Rejected",value:"rejected"},
];
const paymentManagmentStatus=[
  {label:"Completed",value:"completed"},
  {label:"Pending",value:"pending"},
  {label:"Rejected",value:"rejected"},
  {label:"Partially Paid",value:"partially_paid"},
];
const TemplateInfo = [
  {
    label: "Furniture Chair Template",
    value: "1",
    data: [
      {
        item_name: "item1",
        item_code: "001",
        item_price: "500",
        item_quantity: 2,
        item_amount: 1000
      },
      {
        item_name: "item2",
        item_code: "002",
        item_price: "300",
        item_quantity: 4,
        item_amount: 1200
      }
    ]
  },
  {
    label: "Furniture Table Template",
    value: "2",
    data: [
      {
        item_name: "item21",
        item_code: "0021",
        item_price: "500",
        item_quantity: 2,
        item_amount: 1000
      },
      {
        item_name: "item22",
        item_code: "0022",
        item_price: "300",
        item_quantity: 4,
        item_amount: 1200
      }
    ]
  },
  {
    label: "Furniture Counter Template",
    value: "3",
    data: [
      {
        item_name: "item31",
        item_code: "0031",
        item_price: "500",
        item_quantity: 2,
        item_amount: 1000
      },
      {
        item_name: "item32",
        item_code: "0032",
        item_price: "300",
        item_quantity: 4,
        item_amount: 1200
      }
    ]
  },
  {
    label: "Furniture Light Template",
    value: "4",
    data: [
      {
        item_name: "item41",
        item_code: "0041",
        item_price: "500",
        item_quantity: 2,
        item_amount: 1000
      },
      {
        item_name: "item42",
        item_code: "0042",
        item_price: "300",
        item_quantity: 4,
        item_amount: 1200
      }
    ]
  }
];

const qualificationOptions = [
  { label: "Secondary", value: "secondary" },
  { label: "Senior Secondary", value: "senior secondary" },
  { label: "Graduate", value: "graduate" },
  { label: "Post Graduate", value: "post graduate" },
  { label: "Other", value: "other" }
];
const knowledgeOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" }
];

const steps = [
  {
    label: "New Request",
    slug: "new_request"
  },
  {
    label: "Location Check",
    slug: "location_check"
  },
  {
    label: "Document Verification",

    slug: "document_verification"
  },
  {
    label: "Furniture Setup",

    slug: "Furniture"
  },
  {
    label: "Deposit Check",

    slug: "deposit_check"
  },
  {
    label: "Material Dispatch",
    slug: "material_dispatch"
  },
  {
    label: "Material Handover",
    slug: "material_handover"
  }
];

const nearestDepot = [
  {
    label: "Bhilwara (central)",
    value: "10001"
  },
  {
    label: "Jaipur",
    value: "10002"
  },
  {
    label: "Jodhpur",
    value: "10003"
  },
  {
    label: "Udaipur",
    value: "10006"
  },
  {
    label: "Ghaziabad",
    value: "10011"
  },
  {
    label: "Gorakhpur",
    value: "10013"
  },
  {
    label: "Lucknow",
    value: "10015"
  },
  {
    label: "Midnapur",
    value: "10018"
  },
  {
    label: "Siliguri",
    value: "10019"
  },
  {
    label: "Durgapur",
    value: "10020"
  },
  {
    label: "Old Dadar",
    value: "10022"
  },
  {
    label: "Beltala Guwahati",
    value: "10030"
  },
  {
    label: "Jorhat",
    value: "10031"
  },
  {
    label: "Rajkot",
    value: "10035"
  },
  {
    label: "Surat",
    value: "10036"
  },
  {
    label: "Rohtak",
    value: "10037"
  },
  {
    label: "Kurukshetra",
    value: "10038"
  },
  {
    label: "Rewari",
    value: "10039"
  },
  {
    label: "Deoghar",
    value: "10043"
  },
  {
    label: "Hazaribagh",
    value: "10044"
  },
  {
    label: "Gulbarga",
    value: "10046"
  },
  {
    label: "Bengaluru",
    value: "10047"
  },
  {
    label: "Chengannur",
    value: "10048"
  },
  {
    label: "Vellayil(calicut)",
    value: "10049"
  },
  {
    label: "Akola",
    value: "10053"
  },
  {
    label: "Rourkela",
    value: "10056"
  },
  {
    label: "Jalandhar",
    value: "10059"
  },
  {
    label: "Ludhiana",
    value: "10060"
  },
  {
    label: "Old Chennai",
    value: "10062"
  },
  {
    label: "Dhanbad",
    value: "10064"
  },
  {
    label: "Katihar",
    value: "10065"
  },
  {
    label: "Muzaffarpur",
    value: "10066"
  },
  {
    label: "Darbhanga",
    value: "10067"
  },
  {
    label: "Guwahati-tea",
    value: "10078"
  },
  {
    label: "Patna",
    value: "10079"
  },
  {
    label: "Shimla",
    value: "10081"
  },
  {
    label: "Balasore",
    value: "10091"
  },
  {
    label: "Lakhisarai",
    value: "10093"
  },
  {
    label: "Jamshedpur",
    value: "10098"
  },
  {
    label: "Kanpur",
    value: "10099"
  },
  {
    label: "Varanasi",
    value: "10100"
  },
  {
    label: "Allahabad",
    value: "10101"
  },
  {
    label: "Kolhapur",
    value: "10107"
  },
  {
    label: "Sri Ganganagar",
    value: "10108"
  },
  {
    label: "Ner-chowk Mandi",
    value: "10109"
  },
  {
    label: "Gauchar",
    value: "10110"
  },
  {
    label: "Delhi",
    value: "10111"
  },
  {
    label: "Bhiwandi",
    value: "10112"
  },
  {
    label: "Erode",
    value: "10115"
  },
  {
    label: "Gwalior",
    value: "10116"
  },
  {
    label: "Raipur",
    value: "10117"
  },
  {
    label: "Ranchi",
    value: "10118"
  },
  {
    label: "Ahmedabad",
    value: "10119"
  },
  {
    label: "Agartala",
    value: "10122"
  },
  {
    label: "Haldwani",
    value: "10124"
  },
  {
    label: "Hyderabad-new",
    value: "10127"
  },
  {
    label: "Kadapa",
    value: "10130"
  },
  {
    label: "Indore",
    value: "10132"
  },
  {
    label: "Kolkata-kestopur",
    value: "10133"
  },
  {
    label: "Korba",
    value: "10134"
  },
  {
    label: "Bettiah Bihar",
    value: "10136"
  },
  {
    label: "Jabalpur",
    value: "10140"
  },
  {
    label: "Ambikapur",
    value: "10141"
  },
  {
    label: "Kota",
    value: "10143"
  },
  {
    label: "Guntur",
    value: "10144"
  },
  {
    label: "Bishalgarh(tripura)",
    value: "10146"
  },
  {
    label: "Madurai",
    value: "10147"
  },
  {
    label: "Karimnagar New",
    value: "10149"
  },
  {
    label: "Jagdalpur",
    value: "10150"
  },
  {
    label: "Tinsukia",
    value: "10151"
  },
  {
    label: "Dadar-new",
    value: "10152"
  },
  {
    label: "Nagpur-new",
    value: "10153"
  },
  {
    label: "Kolkata",
    value: "10154"
  },
  {
    label: "Pune-new",
    value: "10155"
  },
  {
    label: "Dhekiajuli Assam",
    value: "10158"
  },
  {
    label: "Aurangabad Maharashtra",
    value: "10159"
  },
  {
    label: "Nanded",
    value: "10161"
  },
  {
    label: "Malda",
    value: "10163"
  },
  {
    label: "Hailakandi Assam",
    value: "10164"
  },
  {
    label: "Kaipamangalam-thrishur",
    value: "10165"
  },
  {
    label: "Cuttack",
    value: "10167"
  },
  {
    label: "Jammu",
    value: "10169"
  },
  {
    label: "Dimapur",
    value: "10170"
  },
  {
    label: "Jablipora-bijbehra",
    value: "10176"
  },
  {
    label: "Silvassa",
    value: "10177"
  },
  {
    label: "Towa(arunachal Pradesh)",
    value: "10178"
  },
  {
    label: "Rewa",
    value: "10179"
  },
  {
    label: "Warangal",
    value: "10181"
  },
  {
    label: "Nirmal",
    value: "10182"
  },
  {
    label: "Kapasiya Saharsa",
    value: "10183"
  },
  {
    label: "Hubli New",
    value: "10184"
  },
  {
    label: "Siwan",
    value: "10185"
  },
  {
    label: "Bhopal",
    value: "10186"
  },
  {
    label: "Gaya Bihar",
    value: "10187"
  },
  {
    label: "Azamgarh",
    value: "10188"
  },
  {
    label: "Valsad",
    value: "10189"
  },
  {
    label: "Rasra Ballia",
    value: "10190"
  },
  {
    label: "Sabbavaram-vishakhapatnam",
    value: "10191"
  },
  {
    label: "Mudichur-chennai",
    value: "10192"
  },
  {
    label: "Pithoragarh",
    value: "10193"
  },
  {
    label: "Dehradun-new",
    value: "10194"
  },
  {
    label: "Imphal-new",
    value: "10195"
  },
  {
    label: "Kishanganj Belwa",
    value: "10196"
  },
  {
    label: "Shahdol",
    value: "10198"
  },
  {
    label: "Narath- Kannur",
    value: "10199"
  },
  {
    label: "Sirsa",
    value: "10200"
  },
  {
    label: "Bikaner",
    value: "10201"
  },
  {
    label: "Forbesganj",
    value: "10203"
  },
  {
    label: "Ayodhya Faizabad",
    value: "10204"
  },
  {
    label: "Raghunathganj",
    value: "10205"
  },
  {
    label: "Punaura Sitamarhi",
    value: "10207"
  },
  {
    label: "Neemuch",
    value: "10208"
  },
  {
    label: "Bareilly",
    value: "10209"
  },
  {
    label: "Arrah-bihar",
    value: "10212"
  },
  {
    label: "Bhuj",
    value: "10214"
  },
  {
    label: "Deesa",
    value: "10215"
  },
  {
    label: "Umerkote-odisha",
    value: "10217"
  },
  {
    label: "Krishnanagar",
    value: "10218"
  },
  {
    label: "Sultanpur",
    value: "10219"
  },
  {
    label: "Begusarai",
    value: "10220"
  },
  {
    label: "Kanker",
    value: "10222"
  },
  {
    label: "Muzaffar Nagar",
    value: "10223"
  },
  {
    label: "Bhinmal",
    value: "10224"
  },
  {
    label: "Renukoot",
    value: "10225"
  },
  {
    label: "Deoria",
    value: "10226"
  },
  {
    label: "Agartala-new",
    value: "10227"
  },
  {
    label: "Agra",
    value: "10228"
  },
  {
    label: "Bhagalpur",
    value: "10229"
  },
  {
    label: "Bilaspur",
    value: "10230"
  },
  {
    label: "Samastipur",
    value: "10231"
  },
  {
    label: "Barmer",
    value: "10232"
  },
  {
    label: "Daltonganj",
    value: "10233"
  },
  {
    label: "Saraygarh(bihar)",
    value: "10234"
  },
  {
    label: "Nawadah",
    value: "10235"
  },
  {
    label: "Barharwa-jharkhand",
    value: "10237"
  },
  {
    label: "Dawaguri-cooch Behar",
    value: "10238"
  },
  {
    label: "Mangaluru",
    value: "10239"
  },
  {
    label: "Jhalrapatan",
    value: "10240"
  },
  {
    label: "Muzaffarpur Cloth Depot",
    value: "10241"
  },
  {
    label: "Durgavati-kaimur",
    value: "10242"
  },
  {
    label: "Nagaur",
    value: "10243"
  },
  {
    label: "Mirzapur",
    value: "10246"
  },
  {
    label: "Madhubani",
    value: "10247"
  },
  {
    label: "Nagaon",
    value: "10248"
  },
  {
    label: "Karuvarakundu-malappuram",
    value: "10251"
  },
  {
    label: "Chandrapur",
    value: "10253"
  },
  {
    label: "Poredom-kollam",
    value: "10254"
  },
  {
    label: "Khandwa",
    value: "10257"
  },
  {
    label: "Chhindwara",
    value: "10258"
  },
  {
    label: "Amaravati",
    value: "10260"
  },
  {
    label: "Sikar",
    value: "10262"
  },
  {
    label: "Dangerpora-ganderbal",
    value: "10264"
  },
  {
    label: "Vadodara",
    value: "10265"
  },
  {
    label: "Pusad-maharashtra",
    value: "10266"
  },
  {
    label: "Lakhimpur Kheri",
    value: "10268"
  },
  {
    label: "Himmatnagar",
    value: "10270"
  },
  {
    label: "Dumraon-buxar",
    value: "10272"
  },
  {
    label: "Baruipur-wb",
    value: "10273"
  },
  {
    label: "Jaunpur",
    value: "10274"
  },
  {
    label: "Sangam Vihar-delhi",
    value: "10275"
  },
  {
    label: "Beed-maharashtra",
    value: "10276"
  },
  {
    label: "Chinyalisaur-uk",
    value: "10277"
  },
  {
    label: "Moradabad",
    value: "10278"
  },
  {
    label: "Bengaluru Tulsi Paint",
    value: "10279"
  },
  {
    label: "Fazilka",
    value: "10280"
  },
  {
    label: "Chennai Paint And Non Fmcg",
    value: "10281"
  },
  {
    label: "Gulbarga-paint Depot",
    value: "10282"
  },
  {
    label: "Bhawanipatna",
    value: "10283"
  },
  {
    label: "Nagpur Paint Depot",
    value: "10284"
  },
  {
    label: "Ahmednagar Paint Depot",
    value: "10286"
  },
  {
    label: "Chhapra",
    value: "10287"
  },
  {
    label: "Ranchi-paint Depot",
    value: "10288"
  }
];

const bankNameList = [
  {
    label: "Allahabad Bank",
    value: "101"
  },
  {
    label: "Andhra Bank",
    value: "102"
  },
  {
    label: "Bank Of Baroda",
    value: "103"
  },
  {
    label: "Bank Of India",
    value: "104"
  },
  {
    label: "Bank Of Maharashtra",
    value: "105"
  },
  {
    label: "Canara Bank",
    value: "106"
  },
  {
    label: "Central Bank Of India",
    value: "107"
  },
  {
    label: "Corporation Bank",
    value: "108"
  },
  {
    label: "Dena Bank",
    value: "109"
  },
  {
    label: "Indian Bank",
    value: "110"
  },
  {
    label: "Indian Overseas Bank",
    value: "111"
  },
  {
    label: "Oriental Bank Of Commerce",
    value: "112"
  },
  {
    label: "Punjab And Sind Bank",
    value: "113"
  },
  {
    label: "Punjab National Bank",
    value: "114"
  },
  {
    label: "State Bank Of India",
    value: "115"
  },
  {
    label: "State Bank Of Bikaner &amp; Jaipur",
    value: "116"
  },
  {
    label: "State Bank Of Hyderabad",
    value: "117"
  },
  {
    label: "State Bank Of Indore",
    value: "118"
  },
  {
    label: "State Bank of Mysore",
    value: "119"
  },
  {
    label: "State Bank Of Patiala",
    value: "120"
  },
  {
    label: "State Bank of Saurashtra",
    value: "121"
  },
  {
    label: "State Bank Of Travancore",
    value: "122"
  },
  {
    label: "Syndicate Bank",
    value: "123"
  },
  {
    label: "Uco Bank",
    value: "124"
  },
  {
    label: "Union Bank Of India",
    value: "125"
  },
  {
    label: "United Bank Of India",
    value: "126"
  },
  {
    label: "Vijaya Bank",
    value: "127"
  },
  {
    label: "Development Credit Bank Ltd.",
    value: "128"
  },
  {
    label: "Hdfc Bank Ltd.",
    value: "129"
  },
  {
    label: "Icici Bank Ltd.",
    value: "130"
  },
  {
    label: "Indusind Bank Ltd.",
    value: "131"
  },
  {
    label: "Kotak Mahindra Bank",
    value: "132"
  },
  {
    label: "Axis Bank",
    value: "133"
  },
  {
    label: "Yes Bank Ltd.",
    value: "134"
  },
  {
    label: "Bank of Rajasthan Ltd.",
    value: "135"
  },
  {
    label: "Catholic Syrian Bank Ltd.",
    value: "136"
  },
  {
    label: "City Union Bank Ltd.",
    value: "137"
  },
  {
    label: "Dhanalakshmi Bank Ltd.",
    value: "138"
  },
  {
    label: "Federal Bank Ltd",
    value: "139"
  },
  {
    label: "ING Vysya Bank Ltd.",
    value: "140"
  },
  {
    label: "Jammu And Kashmir Bank",
    value: "141"
  },
  {
    label: "Karur Vysya Bank Ltd.",
    value: "142"
  },
  {
    label: "Karnataka Bank Ltd.",
    value: "143"
  },
  {
    label: "Lakshmi Vilas Bank Ltd.",
    value: "144"
  },
  {
    label: "Ratnakar Bank Ltd.",
    value: "145"
  },
  {
    label: "SBI Commercial and International Bank Ltd.",
    value: "146"
  },
  {
    label: "South Indian Bank Ltd.",
    value: "147"
  },
  {
    label: "Tamilnad Mercantile Bank Ltd.",
    value: "148"
  },
  {
    label: "United Western Bank Ltd.",
    value: "149"
  },
  {
    label: "Abn-amro Bank N.v.",
    value: "150"
  },
  {
    label: "Abu Dhabi Commercial Bank Ltd.",
    value: "151"
  },
  {
    label: "American Express Bank Ltd.",
    value: "152"
  },
  {
    label: "Barclays Bank PLC",
    value: "153"
  },
  {
    label: "BNP Paribas",
    value: "154"
  },
  {
    label: "Citibank N.A.",
    value: "155"
  },
  {
    label: "DBS Bank Ltd",
    value: "156"
  },
  {
    label: "Deutsche Bank Ag",
    value: "157"
  },
  {
    label: "Hsbc Ltd.",
    value: "158"
  },
  {
    label: "Standard Chartered Bank",
    value: "159"
  },
  {
    label: "State Bank of Mauritius Ltd.",
    value: "160"
  },
  {
    label: "Nainital Bank Ltd.",
    value: "161"
  },
  {
    label: "Centurian Bank",
    value: "162"
  },
  {
    label: "Idbi Bank Ltd.",
    value: "163"
  },
  {
    label: "The Bank Of Rajasthan",
    value: "164"
  },
  {
    label: "Bank Of America",
    value: "166"
  },
  {
    label: "Rcm1",
    value: "167"
  },
  {
    label: "Axis Bank Swap",
    value: "169"
  },
  {
    label: "Other Bank",
    value: "170"
  },
  {
    label: "Haryana Gramin Bank",
    value: "171"
  },
  {
    label: "The West Bengal State Cooperative Bank Ltd",
    value: "172"
  },
  {
    label: "Janaseva Sahakari Bank Ltd. Pune",
    value: "173"
  },
  {
    label: "The Gujarat State Co-operative Bank Ltd.",
    value: "174"
  },
  {
    label: "Abhyudaya Co-op Bank Ltd",
    value: "177"
  },
  {
    label: "The A.p. Mahesh Co-op Urban Bank Ltd.",
    value: "178"
  },
  {
    label: "The Karad Urban Co-op Bank Ltd",
    value: "179"
  },
  {
    label: "Tumkur Grain Merchants Cooperative Bank Ltd.",
    value: "180"
  },
  {
    label: "The Surat Peoples Co-op Bank Ltd.",
    value: "181"
  },
  {
    label: "Kapole Co Op Bank",
    value: "182"
  },
  {
    label: "Mahanagar Co-op Bank Ltd",
    value: "183"
  },
  {
    label: "Almora Urban Co-operative Bank Ltd",
    value: "184"
  },
  {
    label: "Karnataka Vikas Grameena Bank",
    value: "185"
  },
  {
    label: "Gurgaon Gramin Bank",
    value: "186"
  },
  {
    label: "Prime Co Operative B",
    value: "187"
  },
  {
    label: "Punjab &amp; Maharashtra",
    value: "188"
  },
  {
    label: "The Kangra Cooperati",
    value: "189"
  },
  {
    label: "Andhra Pragathi Grameena Bank",
    value: "190"
  },
  {
    label: "SARASWAT CO-OPERATIVE BANK LTD",
    value: "191"
  },
  {
    label: "Baroda Rajasthan Gramin Bank",
    value: "192"
  },
  {
    label: "Baroda Uttar Pradesh Gramin Bank",
    value: "193"
  },
  {
    label: "Bangiya Gramin Vikash Bank",
    value: "194"
  },
  {
    label: "Aryavart Gb-gomti Nagar Br",
    value: "195"
  },
  {
    label: "The Mehsana Urban Cooperative Bank Ltd",
    value: "196"
  },
  {
    label: "Nadia District Central Co Operative Bank Ltd",
    value: "197"
  },
  {
    label: "Prathma Bank",
    value: "198"
  },
  {
    label: "The Varachna Copretive Bank Ltd",
    value: "199"
  },
  {
    label: "The Cosmos Co-operative Bank Ltd",
    value: "200"
  },
  {
    label: "The Surat District Co-operative Bank Ltd",
    value: "201"
  },
  {
    label: "Nkgsb Co-operative Bank Ltd",
    value: "202"
  },
  {
    label: "New India Bank",
    value: "203"
  },
  {
    label: "Kerala Gramin Bank",
    value: "204"
  },
  {
    label: "Uttar Bihar Gramin Bank",
    value: "205"
  },
  {
    label: "Shreyas Gramin Bank",
    value: "206"
  },
  {
    label: "The Thane District Central Co.op.bank Ltd",
    value: "207"
  },
  {
    label: "Dombivli Nagari Sahakari Bank Ltd",
    value: "208"
  },
  {
    label: "The Shamrao Vithal Co-op Bank Ltd",
    value: "209"
  },
  {
    label: "The Mahanagar Co-op Bank Ltd",
    value: "210"
  },
  {
    label: "Central Madhya Pradesh Gramin Bank",
    value: "211"
  },
  {
    label: "Dbs Bank",
    value: "212"
  },
  {
    label: "Tjsb Sahakari Bank Ltd",
    value: "213"
  },
  {
    label: "The Kalupur Commercial Co -op Bank Ltd",
    value: "214"
  },
  {
    label: "The Karanataka State Co-op Apex Bank Lltd",
    value: "215"
  },
  {
    label: "Rajkot Nagarik Sahakari Bank Ltd",
    value: "216"
  },
  {
    label: "The Delhi State Cooperative Bank",
    value: "217"
  },
  {
    label: "North Malabar Gramin Bank",
    value: "218"
  },
  {
    label: "Kurmanchal Nagar Sahakari Bank Ltd",
    value: "219"
  },
  {
    label: "Bassein Catholic Co Operative Bank Ltd",
    value: "220"
  },
  {
    label: "Jila Sahakari Bank Maryadit Khargone",
    value: "221"
  },
  {
    label: "Kallappanna Awade Ich Janatas Bank",
    value: "222"
  },
  {
    label: "Jankalyan Sahakari Bank Ltd",
    value: "223"
  },
  {
    label: "Jila Sahakari Bank Ltd",
    value: "224"
  },
  {
    label: "Punjab Gramin Bank",
    value: "225"
  },
  {
    label: "The Kalyan Janata Sahakari Bank Ltd",
    value: "226"
  },
  {
    label: "The Sutex Co-op Bank",
    value: "227"
  },
  {
    label: "Sdc Bank",
    value: "228"
  },
  {
    label: "The Ahmedabad Mercantie Co-op Bank Ltd.",
    value: "229"
  },
  {
    label: "Bharatiya Mahila Bank",
    value: "230"
  },
  {
    label: "Jalgaon Janata Sahakari Bank Ltd.",
    value: "231"
  },
  {
    label: "The Kangra Central Co-operative Bank Ltd.",
    value: "232"
  },
  {
    label: "Vasai Vikas Sahkari Bank Ltd.",
    value: "233"
  },
  {
    label: "Parsik Janata Sahakari Bank Ltd",
    value: "234"
  },
  {
    label: "Capital Local Area Bank Ltd.",
    value: "235"
  },
  {
    label: "The Andhra Pradesh State Co. Bank Ltd",
    value: "236"
  },
  {
    label: "Thane Bharat Sahakari Bank Ltd",
    value: "237"
  },
  {
    label: "Mumbai District Central Co-op. Bank Ltd",
    value: "238"
  },
  {
    label: "The Bharat Co-operative Bank (mumbai) Ltd",
    value: "239"
  },
  {
    label: "The Greater Bombay Co-op. Bank Ltd",
    value: "240"
  },
  {
    label: "Apna Sahakari Bank Ltd",
    value: "241"
  },
  {
    label: "The Rajasthan State Cooperative Bank Ltd.",
    value: "242"
  },
  {
    label: "Janata Sahakari Bank Ltd (pune)",
    value: "243"
  },
  {
    label: "Kokan Mercantile Co- Operative Bank Ltd",
    value: "244"
  },
  {
    label: "The Nasik Merchants Co-op Bank Ltd",
    value: "245"
  },
  {
    label: "Janaseva Sahkari Bank (borivli) Ltd.",
    value: "246"
  },
  {
    label: "Shri Chhatrapati Rajarshi Shahu Urban Co-op Bank L",
    value: "247"
  },
  {
    label: "Pragathi Krishna Gramin Bank",
    value: "248"
  },
  {
    label: "Nagpur Nagrik Sahakari Bank Ltd",
    value: "249"
  },
  {
    label: "The Vishweshwar Sahakari Bank Ltd, Pune",
    value: "250"
  },
  {
    label: "The Bharatpur Central Co-op Bank Ltd.",
    value: "251"
  },
  {
    label: "Gadchiroli District Central Cooperative Bank Ltd",
    value: "252"
  },
  {
    label: "Akola District Central Co-operative Bank",
    value: "253"
  },
  {
    label: "Bandhan Bank Limited",
    value: "254"
  },
  {
    label: "Maharashtra State Co Operative Bank",
    value: "255"
  },
  {
    label: "Rajgurunagar Sahakari Bank Ltd.",
    value: "256"
  },
  {
    label: "Nutan Nagarik Sahakari Bank Ltd.",
    value: "257"
  },
  {
    label: "The Jalgaon Peoples Co-op Bank Ltd",
    value: "258"
  },
  {
    label: "Surat National Co-op. Bank Ltd",
    value: "259"
  },
  {
    label: "The Seva Vikas Co Op",
    value: "260"
  },
  {
    label: "The Hasti Coop Bank Ltd",
    value: "261"
  },
  {
    label: "The Zoroastrian Cooperative Bank Ltd",
    value: "262"
  },
  {
    label: "Citizen Credit Co Op. Bank Ltd.",
    value: "263"
  },
  {
    label: "Tamilnadu State Apex Co-op Bank Ltd",
    value: "264"
  },
  {
    label: "Idfc Bank Ltd",
    value: "265"
  },
  {
    label: "Nagar Urban Co-operative Bank",
    value: "266"
  },
  {
    label: "The Municipal Co Operative Bank Ltd Mumbai",
    value: "267"
  },
  {
    label: "The Akola Janata Commercial Co Op. Bank Ltd",
    value: "268"
  },
  {
    label: "Shivalik Mercantile Co Operative Bank Ltd",
    value: "269"
  },
  {
    label: "Idukki District Co Operative Bank",
    value: "270"
  },
  {
    label: "Maharashtra Gramin Bank",
    value: "271"
  },
  {
    label: "Deogiri Nagari Sahakari Bank Ltd Aurangabad",
    value: "272"
  },
  {
    label: "Au Small Finance Bank",
    value: "273"
  },
  {
    label: "Ujjivan Small Finance Bank",
    value: "274"
  },
  {
    label: "Equitas Small Finance Bank Limited",
    value: "275"
  },
  {
    label: "Suryoday Small Finance Bank",
    value: "276"
  },
  {
    label: "Fino Payments Bank",
    value: "277"
  },
  {
    label: "Esaf Small Finance Bank",
    value: "278"
  },
  {
    label: "Kozhikode District Co-op Bank",
    value: "279"
  },
  {
    label: "Utkarsh Small Finance Bank",
    value: "280"
  },
  {
    label: "Thrissur District Co Operative Bank",
    value: "281"
  },
  {
    label: "Durgapur Steel Peoples Co-operative Bank Ltd",
    value: "282"
  },
  {
    label: "Telangana State Coop Apex Bank",
    value: "283"
  },
  {
    label: "Andhra Pradesh Grameena Vikas Bank",
    value: "284"
  },
  {
    label: "Himachal Pradesh State Cooperative Bank Ltd",
    value: "285"
  },
  {
    label: "Kaveri Grameena Bank",
    value: "286"
  },
  {
    label: "Capital Small Finance Bank Limited",
    value: "287"
  },
  {
    label: "Ahmednagar Merchants Co-op Bank Ltd",
    value: "288"
  },
  {
    label: "North East Small Finance Bank Limited",
    value: "289"
  },
  {
    label: "Irinjalakuda Town Co-operative Bank Ltd",
    value: "290"
  },
  {
    label: "Solapur Janata Sahkari Bank Ltd.solapur",
    value: "291"
  },
  {
    label: "The Pandharpur Urban Co Op. Bank Ltd. Pandharpur",
    value: "292"
  },
  {
    label: "Jana Small Finance Bank",
    value: "293"
  },
  {
    label: "India Post Payments Bank",
    value: "294"
  },
  {
    label: "Rajasthan Marudhara Gramin Bank",
    value: "295"
  },
  {
    label: "The Sindhudurg District Central Coop Bank Ltd",
    value: "296"
  },
  {
    label: "Paytm Payments Bank Ltd",
    value: "297"
  },
  {
    label: "Shikshak Sahakari Bank Limited",
    value: "298"
  },
  {
    label: "VASAI JANATA SAHAKARI BANK LTD",
    value: "299"
  },
  {
    label: "Ambarnath Jaihind Coop Bank Ltd",
    value: "300"
  },
  {
    label: "Dmk Jaoli Bank",
    value: "301"
  },
  {
    label: "Fincare Small Finance Bank Ltd",
    value: "302"
  },
  {
    label: "The Aurangabad District Central Co-op Bank Ltd.",
    value: "304"
  },
  {
    label: "Rbl Bank",
    value: "305"
  },
  {
    label: "The Baramati Sahakari Bank Ltd",
    value: "306"
  },
  {
    label: "The Malkapur Urban Co Operative Bank Ltd",
    value: "307"
  },
  {
    label: "The Udaipur Urban Co Operative Bank Ltd",
    value: "308"
  },
  {
    label: "The Navnirman Co. Op",
    value: "309"
  },
  {
    label: "Uttar Pradesh Cooperative Bank",
    value: "310"
  },
  {
    label: "Nilambur Co-operative Urban Bank",
    value: "311"
  },
  {
    label: "The Urban Co Operative Bank Perinthalmanna",
    value: "312"
  },
  {
    label: "The Nav Jeevan Co-op Bank Ltd",
    value: "313"
  },
  {
    label: "Chndra",
    value: "314"
  },
  {
    label: "The Kerala State Co Operative",
    value: "315"
  },
  {
    label: "The Vijay Co Operative Bank Limited",
    value: "316"
  },
  {
    label: "The Odisha State Cooperative Bank Ltd",
    value: "317"
  },
  {
    label: "Nsdl Payments Bank",
    value: "318"
  },
  {
    label: "Suco Souharda Sahakari Bank",
    value: "319"
  },
  {
    label: "Satara Sahakari Bank",
    value: "320"
  },
  {
    label: "Rajarshi Shahu Sahakari Bank Ltd",
    value: "321"
  },
  {
    label: "Bombay Mercantile Co Op Bank Limited",
    value: "322"
  },
  {
    label: "The Muslim Co-operative Bank Ltd",
    value: "323"
  },
  {
    label: "Model Co-op Bank Ltd",
    value: "324"
  },
  {
    label: "Chhattisgarh Rajya Gramin Bank",
    value: "325"
  },
  {
    label: "Rajnandgaon District Central Co-operative Bank Ltd",
    value: "326"
  },
  {
    label: "Ahmednagar District Central Co-op Bank",
    value: "327"
  },
  {
    label: "Shri Veershaiv Co Op Bank Ltd",
    value: "328"
  },
  {
    label: "Saraspur Nagrik Co Operative",
    value: "329"
  },
  {
    label: "Saurashtra Gramin Bank",
    value: "330"
  },
  {
    label: "Samarth Sahakari Bank Ltd",
    value: "331"
  },
  {
    label: "The Satara District Central Co-operative Bank Ltd",
    value: "332"
  },
  {
    label: "Arvind Sahakari Bank Ltd",
    value: "333"
  },
  {
    label: "Shinhan Bank",
    value: "334"
  }
];
const isSubmenuInPermissions = (subMenu, permissions) => {
  if (!subMenu || !Array.isArray(subMenu)) {
    return false;
  }

  for (const item of subMenu) {
    if (permissions.includes(item.route)) {
      return true;
    }

    if (item.subMenu) {
      const isSubmenuFound = isSubmenuInPermissions(item.subMenu, permissions);
      if (isSubmenuFound) {
        return true;
      }
    }
  }

  return false;
};
const validQualifications = ["secondary", "senior secondary", "graduate", "post graduate"];

const applicantGenderOptions = [
  { label: "Female", value: "female" },
  { label: "Male", value: "male" },
  { label: "Transgender", value: "transgender" },
  { label: "Other", value: "other" }
];

export {
  matches,
  validationMessage,
  nearestDepot,
  ASSOCIATE_BUYER_SLUG,
  TemplateInfo,
  isSubmenuInPermissions,
  bankNameList,
  actionsPermissionValidator,
  actionsUserPermissionValidator,
  associate_buyer,
  PermissionAction,
  steps,
  SUPER_ADMIN,
  saleTargetOptions,
  bussinessIdentityOptions,
  premisesTypeOptions,
  dummyDeropDown,
  locationType,
  floorType,
  rolestatus,
  paymentStatus,
  paymentManagmentStatus,
  knowledgeOptions,
  qualificationOptions,
  validQualifications,
  applicantGenderOptions
};
